"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    transition-property: color, text-decoration;\n    ", ";\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      inText = _ref.inText;
  var palette = theme.palette;
  return {
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    color: inText ? theme.inTextColor : theme.color,
    textDecoration: inText ? theme.inTextTextDecoration : theme.textDecoration,
    '&:hover': {
      color: inText ? theme.inTextHoverColor : theme.hoverColor,
      textDecoration: inText ? theme.inTextHoverTextDecoration : theme.hoverTextDecoration,
      cursor: 'pointer'
    }
  };
};

var Root = _styledComponents["default"].a(_templateObject(), function (props) {
  return props.theme;
}, function (props) {
  return base(props);
});

var _default = Root;
exports["default"] = _default;